<template>
  <div class="panel">
    <div class="title htitle fs20">{{title}}</div>
    <div class="info">
      <div v-for="(value, key) in infos" class="line">
        <div class="key"><b>{{key}}</b></div>
        <div class="value">{{value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   name: '',
   props: ['infos', 'title']
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .panel{
   display:flex;
   flex-direction: column;
   align-items:center;
   color: #333333;
   width: 32vw;
 }
 .title{
   margin-bottom: 10vh;
 }
  .info{
   align-self: center;
  }
 .line{
   display: flex;
   align-items:center;
  width: 20em;
 }
 .key{
   font-weight: 400;
   /*flex-basis: 6em;*/
   flex:1;
   text-align: right;
   padding-right: .5em;
 }
 .value{
   color:#5C5C5C;
   flex:1;
 }
</style>
